<template>
  <normal-table
    ref="krTable"
    :table-data="row.relatedResult.data.tableData"
    :header-data="row.relatedResult.data.headerData"
    :meta-data="row.relatedResult.meta"
    :redirects="redirects"
  >
    <template slot="empty">
      <slot name="empty" />
    </template>
  </normal-table>
</template>

<script>
import NormalTable from '@inv/components/metaData/krTable/normalTable'

export default {
  name: 'RelatedTable',
  components: {
    NormalTable,
  },
  props: {
    row: kr.vue.getPropObject(),
  },
  data() {
    return {
      redirects: ['/md/module/', 'object_describe_api_name', '/edit/', 'id'],
    }
  },
}

</script>

<style lang="scss" scoped>

</style>
